import TermsScreen from './components/TermsScreen'

export default {
  path: '/terminos-y-condiciones',
  component: TermsScreen,
  name: 'Terms'
}



// WEBPACK FOOTER //
// ./src/app/screens/Terms/index.js